import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import WebcastingContext from "../../context/webcasting/webcastingContext";

import './PresenterItemSmall.css';

const useStyles = makeStyles({
  card: {
    height: '50%',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '0px',
    boxShadow: 'none',
  },
  content: {
    padding: '0.7rem 2.1rem',
    borderRadius: '0px 0px 3px 3px',
    '&:last-child': {
      paddingBottom: '1rem',
    },
  },
  contentDefault: {
    height: '100%',
    padding: '1rem 2rem',
    // padding: '0.7rem 2.1rem',
    borderRadius: '0px',
    backgroundColor: '#fff',
    '&:last-child': {
      paddingBottom: '1rem',
    },
  },
  subtitle: {
    lineHeight: '1',
  },
});

const PresenterItemSmall = ({ active, isOnlyVideo }) => {
  const webcastingContext = useContext(WebcastingContext);
  const {event} = webcastingContext
  const [isFont_title, setIfFont_title] = useState({})
  const [isFont_description, setIfFont_description] = useState({})
  console.log('activeFromPresenterItemSmall', active)
  console.log('presenterCardColors', event?.webcast?.presenterTimes)
  useEffect(()=>{
    const fonts = event?.webcast?.branding?.fonts;
    if (!fonts) return;
    
    // Handle new structure: object with keys (default, title, description)
    if (fonts && typeof fonts === 'object' && !Array.isArray(fonts)) {
      if (fonts.title && Object.keys(fonts.title).length > 0) {
        // Convert new structure to old format for compatibility
        setIfFont_title({
          fontFamily: fonts.title.fontFamily || '',
          fontColor: fonts.title.color || '',
          fontWeight: fonts.title.fontWeight || '',
          fontSizeBase: fonts.title.baseSize || ''
        });
      }
      
      if (fonts.description && Object.keys(fonts.description).length > 0) {
        setIfFont_description({
          fontFamily: fonts.description.fontFamily || '',
          fontColor: fonts.description.color || '',
          fontWeight: fonts.description.fontWeight || '',
          fontSizeBase: fonts.description.baseSize || ''
        });
      }
    }
    // Handle old structure: array
    else if (Array.isArray(fonts) && fonts.length > 0) {
      if (fonts[1] && Object.entries(fonts[1]).length > 0) {
        console.log('Presenter fonts', Object.entries(fonts[1]).length);
        if (Object.entries(fonts[1]).length > 0) {
          console.log('Presenter fonts', fonts[1]);
          setIfFont_title(fonts[1]);
        }
      }

      if (fonts[2] && Object.entries(fonts[2]).length > 0) {
        console.log('Presenter fonts', Object.entries(fonts[2]).length);
        if (Object.entries(fonts[2]).length > 0) {
          console.log('Presenter fonts', fonts[2]);
          setIfFont_description(fonts[2]);
        }
      }
    }
},[event])




  // let presenterImage = '';
  let presenterName = '';
  let presenterPosition = '';
  if (active) {
    // if (active.images[0]) {
    //   if (active.images[0].upload) {
    //     if (active.images[0].upload.path) {
    //       presenterImage = active.images[0].upload.path;
    //     }
    //   }
    // }
    if (active.name) {
      presenterName = active.name;
    }
    if (active?.role) {
      presenterPosition = active?.role;
    }
  }

  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent
        className={
          isOnlyVideo
            ? `${classes.content} only-video-content`
            : `${classes.contentDefault}`
        }
      >
        <Typography component='h5' variant='h6'
          className='title'
        // style={{
        //   fontFamily:Object.entries(isFont_title).length > 0 ? isFont_title.fontFamily : "",
        //   color:Object.entries(isFont_title).length > 0 ? isFont_title.fontColor : "",
        //   fontWeight:Object.entries(isFont_title).length > 0 ? isFont_title.fontWeight : "",
        //   fontSize:Object.entries(isFont_title).length > 0 ? isFont_title.fontSizeBase : "",
        // }}
        
        >
          {presenterName || event?.presenters[0]?.name}
        </Typography>
        <Typography component='h5' variant='h6'
                  className='description'

          // className={classes.subtitle}
          // variant='body2'
          // color='textSecondary'
          // style={{
          //   fontFamily:Object.entries(isFont_description).length > 0 ? isFont_description.fontFamily : "",
          //   color:Object.entries(isFont_description).length > 0 ? isFont_description.fontColor : "",
          //   fontWeight:Object.entries(isFont_description).length > 0 ? isFont_description.fontWeight : "",
          //   fontSize:Object.entries(isFont_description).length > 0 ? isFont_description.fontSizeBase : "",
            
          // }}
        >
          {presenterPosition || event?.presenters[0]?.role}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default React.memo(PresenterItemSmall);
